import { useState } from 'react';

import { AArrowUp } from 'lucide-react';
import { Input, InputGroup, InputGroupText, DefaultTooltip, Select } from 'twyne-new.ui';

import { useCraftProp } from '@/components/builder/utils';

import { UNIT_OPTIONS } from '../utils/predefined_sizes';

function getInitialValue(key, value) {
  const fontSizeRegex = /^(\d+(?:\.\d+)?)([a-zA-Z%]+)$/

  if (typeof value === 'string') {
    const match = value.match(fontSizeRegex)

    if (match) {
      return key === "size" ? match[1] : match[2]
    }
  } else {
    return key === "unit" ? 'px' : null
  }

  return null
}

export default function FontSizeProperty() {
  const { setValue: setFontSize, value: fontSize } = useCraftProp('fontSize')
  const [size, setSize] = useState(getInitialValue('size', fontSize))
  const [unit, setUnit] = useState(getInitialValue('unit', fontSize))

  const handleSizeChange = size => {
    setSize(size)
    setFontSize(`${size}${unit}`)
  }

  const handleUnitChange = unit => {
    setUnit(unit)
    setFontSize(`${size}${unit}`)
  }

  return <>
    <div className='grid grid-cols-1'>
      <InputGroup variant='accent'>
        <DefaultTooltip content='Font Size'>
          <InputGroupText addonType='prepend'>
            <AArrowUp size={14} />
          </InputGroupText>
        </DefaultTooltip>
        <Input
          type='text'
          size='sm'
          value={size}
          onChange={e => handleSizeChange(e.target.value)}
          onKeyDown={e => e.key === ',' && e.preventDefault()}
        />
        <Select
          value={unit}
          onChange={option => handleUnitChange(option?.value)}
          options={UNIT_OPTIONS}
          placeholder='Unit'
          variant='accent'
        />
      </InputGroup>
    </div>
  </>
}
